import * as React from 'react';
import Button from '../../../../common/components/Button';
import {GLOBAL, PAY_WARRANTY_MX} from '../../../constants/LabelConstants';
import AssetsManager from '../../../../common/utils/AssetsManager';
import {PayWarrantyFailedProps} from '../../../types/mx/components';

class PayWarrantyRefusedView extends React.Component<PayWarrantyFailedProps, {}> {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <div className="modal-info">
                    <div className="modal-scroll">
                        <div className="container">
                            <div className="row d-flex justify-content-center mb-5 mt-3">
                                <img src={AssetsManager('/assets/images/common/payment-refused-icon.svg')}/>
                            </div>
                            <div className="row p-none d-flex justify-content-center mb-3">
                                <h2 className="title-step">{PAY_WARRANTY_MX.PAYMENR_REFUSED}</h2>
                            </div>
                            <div className="row p-none d-flex justify-content-center pb-6 border-bottom">
                                {PAY_WARRANTY_MX.PAYMENR_REFUSED_TEXT}
                            </div>
                            <div className="row mt-4">
                                <div className="col-12 d-flex justify-content-center">
                                    <Button text={GLOBAL.ACCEPT} onPress={() => this.props.onPressNext()}
                                            role="button"
                                            customClass="px-md-5" type="outlined"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default PayWarrantyRefusedView;
